import { datastageApi } from '../api';

export function startJobStatusTracker(jobId, onStatusMessage) {
    let stopped = false;
    let lastMessage = null;

    const poll = () => {
        datastageApi
            .jobById(jobId)
            .then((jobStatus) => {
                const data = jobStatus?.data;
                if (!data) {
                    const message = `Job ${jobId}: Unable to fetch status.`;
                    if (message !== lastMessage) {
                        onStatusMessage(message, 'error', null, false);
                        lastMessage = message;
                    }
                    if (!stopped) setTimeout(poll, 2000);
                    return;
                }

                let message = '';
                let status = 'info';
                let isComplete = false;

                if (data.spaJobStatus === 'STARTING') {
                    message = `Job ${data.id} is creating tasks and preparing to start`;
                } else if (data.spaJobStatus === 'RUNNING') {
                    message = `Job ${data.id} progress: ${data.progressCount} out of ${data.targetCount} tasks complete with ${data.errorCount} errors`;
                } else if (data.spaJobStatus === 'COMPLETE') {
                    if (data.errorCount > 0) {
                        message = `Job ${data.id} Complete with ${data.errorCount} errors.`;
                        status = 'warning';
                    } else {
                        message = `Job ${data.id} Complete!`;
                        status = 'success';
                    }
                    stopped = true;
                    isComplete = true;
                } else if (data.spaJobStatus === 'FAILED') {
                    message = `Job ${data.id} failed!`;
                    status = 'error';
                    stopped = true;
                    isComplete = true;
                } else if (data.spaJobStatus === 'ABORTED') {
                    message = `Job ${data.id} was aborted.`;
                    status = 'error';
                    stopped = true;
                    isComplete = true;
                } else {
                    message = `Job ${data.id} status: ${data.spaJobStatus}`;
                    stopped = true;
                }

                // Pass isComplete flag to callback so it can close drawer after delay
                onStatusMessage(message, status, data, isComplete);

                if (!stopped) setTimeout(poll, 2000);
            })
            .catch(() => {
                const message = `Job ${jobId}: Error fetching status.`;
                if (message !== lastMessage) {
                    onStatusMessage(message, 'error', null, false);
                    lastMessage = message;
                }
                stopped = true;
            });
    };

    poll();
}
